export * from './delete-kunden-gruppe.service';
export * from './delete-kunden-gruppe.service.module';